import { Phone } from "lucide-react";
import { motion } from "framer-motion";

const PHONE_NUMBER = "+919270425109";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="py-20 md:py-28 bg-[#14B8A6] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[400px] h-[400px] rounded-full bg-white/5 blur-3xl" />
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full bg-white/5 blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10"
      >
        <h2 className="font-heading text-2xl sm:text-3xl md:text-5xl font-bold text-white tracking-tight mb-6 md:whitespace-nowrap">
          Your Loved Ones Deserve the Best Care.
        </h2>
        <p className="text-lg text-white/80 font-body mb-10 max-w-2xl mx-auto">
          Don't wait. Get compassionate, professional home healthcare for your family today.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#contact"
            data-testid="final-cta-callback"
            className="inline-flex items-center gap-2 h-14 px-10 rounded-full font-semibold bg-white text-[#14B8A6] hover:bg-slate-50 transition-all duration-300 transform hover:-translate-y-1 active:scale-95 shadow-lg font-body text-base"
          >
            Request Call Back
          </a>
          <a
            href={`tel:${PHONE_NUMBER}`}
            data-testid="final-cta-call"
            className="inline-flex items-center gap-2 h-14 px-10 rounded-full font-semibold text-white border-2 border-white/40 hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1 font-body text-base"
          >
            <Phone className="w-5 h-5" />
            Call: +91 9270425109
          </a>
        </div>
      </motion.div>
    </section>
  );
}
